import { LayoutDetails, SingleLayoutDetails } from '@/types/pages/storeManagement/device';
import { ASSOCIATE_PAIRING_MODE } from '@/types/pages/storeManagement/device/associate';

export const createEmptyProductValues = (capacity: number): string[] => {
    return Array.from({ length: capacity }, () => '');
};

export const getInitialPairingMode = (
    normalLayouts: LayoutDetails[] | SingleLayoutDetails[],
    imageLayouts: LayoutDetails[] | SingleLayoutDetails[],
): ASSOCIATE_PAIRING_MODE => {
    if (normalLayouts.length > 0) return ASSOCIATE_PAIRING_MODE.NORMAL;
    if (imageLayouts.length > 0) return ASSOCIATE_PAIRING_MODE.IMAGE;
    return ASSOCIATE_PAIRING_MODE.NORMAL;
};

export const isProductInputEnabledForMode = (
    mode: ASSOCIATE_PAIRING_MODE,
    normalLayouts: LayoutDetails[] | SingleLayoutDetails[],
    imageLayouts: LayoutDetails[] | SingleLayoutDetails[],
): boolean => {
    return mode === ASSOCIATE_PAIRING_MODE.NORMAL ? normalLayouts.length > 0 : imageLayouts.length > 0;
};
